import {INITIAL_LANGUAGE} from '../../locale/types'
import {Map} from '../../utils/immutable'
import {GlobalState, GlobalStateMap} from './types'

export const initialState: GlobalStateMap = Map<GlobalState>({isLoading: false, language: INITIAL_LANGUAGE, isMainFrameScrollable: true})
